// --------------------------------------------------------
// OCCUPATIONAL HEALTH TAB - OccupHealthTab
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { CircularProgress } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import CardPeriodic from '../../../../components/cardPeriodic/CardPeriodic';
import { H1, Text } from '../../../../components/UI/generalLayout/Layout.styled';
import { Spacer } from '../../../../components/UI/spacer/spacer';
import { CompanyService } from '../../../../core/http/service/CompanyService';
import { UserRoleService } from '../../../../core/http/service/UserRoleService';
import { Paths } from '../../../../enums/Paths';
import useResponsiveInfo from '../../../../hooks/useResponsiveInfo';
import { HeaderInformation } from '../../../collaborator/periodics/MyPeriodics.styled';
import { Container, Header } from '../attendanceRecord/AttendanceRecord.styled';
import { useSelector } from 'react-redux';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// OCCUPATIONAL HEALTH TAB INTERFACE
// --------------------------------------------------------

interface IOccupHealthTab {
    pessoa: any
    agendamento: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const OccupHealthTab = ({ pessoa, agendamento }: IOccupHealthTab) => {
    // --------------------------------------------------------
    // OCCUPATIONAL HEALTH TAB PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<any>(false)
    const [occupHealths, setOccupHealths] = useState<any>([])
    const { currentProfile }: any = useSelector((state: any) => state.login);
    
    const fetchOccupHealth = useCallback(async () => {

        try {
            setIsLoading(true)
            const service: UserRoleService = new UserRoleService();
            const companyService: CompanyService = new CompanyService();
            const companies: any[] = [];
            const ghes: any[] = [];
            const response: any = await service.getByPersonId(pessoa.idPessoa);
            response.data.data.forEach((d: any) => {
                companies.push(d.empresa);
            })
            for (let company of companies) {
                const result: any = await companyService.getPeriodicsByCompanyPerson(company.id, pessoa.idPessoa)
                for (let r of result.data.data) {
                    const response: any = await companyService.getCompanySaudeOcupacionalByName(r.nome, company.id)
                    const ghe: any = response.data.data[0];
                    ghes.push({ ...ghe, ...r, nomeEmpresa: company.nomeFantasia });
                }
            }
            setOccupHealths(ghes)
            setIsLoading(false)
            
        } catch (error) {
            setIsLoading(false)
        }

    }, [pessoa])

    useEffect(() => {
        fetchOccupHealth();
    }, [])

    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <Container isMobile={isMobile}>
                <Spacer top={10} />
                <Header style={{ flexDirection: isMobile ? 'column' : 'row' }}>
                    <H1>Saúde ocupacional</H1>
                </Header>
                <Spacer top={30} />
                
                <>
                    {!isLoading ? (<div>
                        {!isMobile && (<HeaderInformation style={{ width: '100%', marginLeft: 0, gap: 12 }}>
                            <Text bold={true} style={{
                                marginLeft: "15%",
                            }}>Nome</Text>
                            <Text
                                style={{
                                    marginLeft: "5%",
                                }}
                                bold={true}
                            >
                                Data prevista
                            </Text>
                            <Text bold={true} style={{
                                marginRight: "10%",
                            }}>Próximos exames</Text>
                        </HeaderInformation>)}
                        {occupHealths.map((ocp: any) => {
                            return <div style={{ cursor: 'pointer' }} onClick={() => { navigate(Paths.DetalharLinhaCuidado, { state: { careLine: ocp, isCareLine: false, pessoa: pessoa } }) }}>
                                <Text bold>{ocp.nomeEmpresa}</Text>
                                <CardPeriodic title={ocp.nome} data={ocp} isCareLine={false} isAppointment={true} />
                            </div>
                        })}

                        {(occupHealths.length === 0 && !isLoading) && (<Text>Nenhum resultado encontrado</Text>)}
                        
                    </div>) : (<div style={{ marginTop: 50, height: 50, textAlign: 'center' }}><CircularProgress /></div>)}
                </>

            </Container>
        </>
    )
    // --------------------------------------------------------
}

export default OccupHealthTab